import * as React from 'react';
import { Link } from 'react-router-dom';
import { BodyGroup, NiSelect } from '@component/index';
import { DeleteOutlined } from '@ant-design/icons';
import { message, Space } from 'antd';
import {
  API,
  SelectionOption,
  getSelectionOptions
} from '@config/index';
import {
  ReferenceNode,
  FrameType,
  ParameterType,
  ServiceSlot
} from '@interface/index';
import { cloneDeep } from 'lodash';
import './style/index.less';
import { localizedString } from '@locale/index';
import { FormattedMessage } from 'react-intl';
import { getOrgId, getAgentId, getAgentPathPrefix } from '@lib/index';

export type ServicesProps = {
  hostId: string;
  hostType: FrameType;
  selectedList: ServiceSlot[];
  disabled?: boolean;
  onChanged: (data: ServiceSlot[], deletedData?: ServiceSlot[]) => void;
  afterLinkClick?: () => void;
};

export type ServicesState = {
  filterText?: string;
  options: SelectionOption[];
};

export class ServicesComp extends React.Component<
  ServicesProps,
  ServicesState
> {
  constructor(props: ServicesProps) {
    super(props);
    this.state = {
      options: []
    };
  }

  componentDidMount() {
    const { hostId, hostType } = this.props;

    if (!hostId) {
      return;
    }

    getSelectionOptions('AVAILABLE_SERVICE', [{
      value: hostId,
      value_type: hostType
    }]).then((res: SelectionOption[]) => {
      this.setState({ options: res });
    });
  }

  render() {
    const {
      hostId,
      hostType,
      selectedList,
      onChanged,
      disabled = false
    } = this.props;

    const { options } = this.state;

    return (
      <BodyGroup
        title={localizedString('services')}
        className="composite-inherit"
        extra={[
          <NiSelect
            disabled={disabled}
            className="composite-inherit-select"
            key="service-select"
            placeholder={localizedString('service_select_placeholder')}
            value={undefined}
            onSelect={async (value: string) => {
              // await API.common.checkFrameDependencyBeforehand(hostId, hostType, value)
              //   .catch((e: any) => {
              //     message.error(e.message);
              //     throw e;
              //   });

              let res: ReferenceNode[] = [];
              if (selectedList) {
                res = cloneDeep(selectedList);
              }

              const opt = options.find((item: SelectionOption) => item.value === value);

              res.push({
                id: value || '',
                name: (opt && opt.label) as string,
                type: (opt && opt.valueType) as ParameterType
              });
              if (onChanged) {
                onChanged(res);
              }
            }}
          >
            {options
              .filter((item: SelectionOption) => {
                if (!selectedList || !selectedList.length) {
                  return true;
                }

                for (const attr of selectedList) {
                  if (attr.id === item.value) {
                    return false;
                  }
                }

                return true;
              })
              .map((item: SelectionOption) => {
                return (
                  <NiSelect.Option key={`avaiable-abstract-${item.value}`} value={String(item.value)}>
                    {item.label}
                  </NiSelect.Option>
                );
              })}
          </NiSelect>
        ]
        }
      >
        {selectedList && selectedList.length ? (
          selectedList.map((item: ServiceSlot) => {
            return (<div className="list-item" key={`list-item-${item.id}`}>
              <Link
                to={`${getAgentPathPrefix()}/service/${item.id}`}
                key={`selected-inherit-${item.id}`}
                replace={false}
              >
                <span
                  onClick={() => {
                    setTimeout(() => {
                      if (this.props.afterLinkClick) {
                        this.props.afterLinkClick();
                      }
                    }, 0.1);
                  }}
                  style={{ color: '#4182eb', fontSize: 14, marginLeft: 16 }}
                >
                  {item.name}
                </span>
              </Link>
              <Space size={32}>{item.inheritedFromCompositeId ? item.inheritedFromCompositeName : 'Local'}
                <div className="admin" style={{ width: 30 }}>
                  {(!disabled && !item.inheritedFromCompositeId) &&
                    <DeleteOutlined style={{ color: 'rgba(0,0,0,.54)', marginLeft: 6 }} onClick={async () => {

                      // await API.common.checkFrameDependency(hostId, hostType, item.id)
                      //   .catch((e: any) => {
                      //     message.error(e.message);
                      //     throw e;
                      //   });

                      const next = selectedList.filter((selected: ReferenceNode) => selected.id !== item.id);
                      onChanged(next, [item]);
                    }} />
                  }
                </div>
              </Space>
            </div>
            );
          })
        ) : (
          <span
            style={{
              color: 'rgba(0,0,0,0.26)',
              fontSize: 14,
              marginLeft: 16,
              cursor: 'default'
            }}
          >
            <FormattedMessage id="inherit_no_data" />
          </span>
        )}
      </BodyGroup>
    );
  }
}
